/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

/*
 * Cookie names the Map Viewer reads and writes.
 *
 * They are shared with the backend, which sets some of them, so the strings
 * are not free to change on one side alone.
 */

/** Where the map's position and zoom are remembered between visits. */
export const MAP_STATE_COOKIE = 'mapState';

/** Which points the reader has already opened, for the metered paywall. */
export const NODES_VISITED_LIST_COOKIE = 'visitedNodes';
